import { render, staticRenderFns } from "./TopBarNotifications.vue?vue&type=template&id=d4e6b7d4&scoped=true&"
import script from "./TopBarNotifications.vue?vue&type=script&lang=js&"
export * from "./TopBarNotifications.vue?vue&type=script&lang=js&"
import style0 from "./TopBarNotifications.vue?vue&type=style&index=0&id=d4e6b7d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4e6b7d4",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/ui/TopBarNotifications.vue
// module id = null
// module chunks = 